import * as yup from 'yup';
import { DepartmentCreateModel, DepartmentUpdateModel } from './department.model';

export const departmentCreateSchema: yup.ObjectSchema<DepartmentCreateModel> = yup.object({
  title_la: yup.string().required('ກະລຸນາປ້ອນຊື່ (LA)'),
  title_en: yup.string().required('ກະລຸນາປ້ອນຊື່ (EN)'),
  description: yup.string().optional(),
});

export const departmentUpdateSchema: yup.ObjectSchema<DepartmentUpdateModel> = yup.object({
  id: yup.string().optional(),
  uuid: yup.string().optional(),
  title_la: yup.string().required('ກະລຸນາປ້ອນຊື່ (LA)'),
  title_en: yup.string().required('ກະລຸນາປ້ອນຊື່ (EN)'),
  description: yup.string().optional(),
});
